module.exports = __webpack_public_path__ + "static/media/400071_01.1e43dada.png";